import React from "react"
import { useTranslation } from "react-i18next"

export default function PPMatchingBulkConfirmModal({
    open,
    shopName,
    minScore,
    openCount,
    loading,
    onConfirm,
    onCancel
}) {
    const [t] = useTranslation()

    if (!open) {
        return null
    }

    return (
        <div className="pp-matching-bulk-modal" role="dialog" aria-modal="true" aria-labelledby="bulk-confirm-title">
            <button
                type="button"
                className="pp-matching-bulk-modal__backdrop"
                onClick={loading ? undefined : onCancel}
                style={{ border: "none", padding: 0 }}
            />
            <div className="pp-matching-bulk-modal__dialog">
                <div className="pp-matching-bulk-modal__header">
                    <h5 className="pp-matching-bulk-modal__title" id="bulk-confirm-title">
                        {t("matching.bulk_confirm_title")}
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onCancel}
                        disabled={loading}
                        aria-label={t("single.cancel")}
                    />
                </div>
                <div className="pp-matching-bulk-modal__body">
                    <p className="mb-0">
                        {t("matching.bulk_confirm_message", {
                            shop: shopName ?? "—",
                            min: minScore,
                            count: openCount
                        })}
                    </p>
                </div>
                <div className="pp-matching-bulk-modal__footer">
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        {t("single.cancel")}
                    </button>
                    <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? t("matching.bulk_confirm_running") : t("matching.bulk_confirm_submit")}
                    </button>
                </div>
            </div>
        </div>
    )
}
